var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 469;
var h = 469;
var nm = "World  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Trending 3",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 8,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234.053,
                    234.921,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.34,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.66,
                                        y: 0
                                    },
                                    t: 8,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    -0.029
                                                ],
                                                [
                                                    0.029,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.029
                                                ],
                                                [
                                                    -0.029,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0.029
                                                ],
                                                [
                                                    -0.029,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.029
                                                ],
                                                [
                                                    0.029,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    0.053,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.053
                                                ],
                                                [
                                                    -0.053,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.053
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                },
                                {
                                    t: 28.0000011404634,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    -52.181
                                                ],
                                                [
                                                    52.181,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    52.181
                                                ],
                                                [
                                                    -52.181,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    52.181
                                                ],
                                                [
                                                    -52.181,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -52.181
                                                ],
                                                [
                                                    52.181,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    94.482,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    94.482
                                                ],
                                                [
                                                    -94.482,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -94.482
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 8.00000032584668,
        op: 908.000036983598,
        st: 8.00000032584668,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Trending 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    235,
                    232,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -52.181
                            ],
                            [
                                52.181,
                                0
                            ],
                            [
                                0,
                                52.181
                            ],
                            [
                                -52.181,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                52.181
                            ],
                            [
                                -52.181,
                                0
                            ],
                            [
                                0,
                                -52.181
                            ],
                            [
                                52.181,
                                0
                            ]
                        ],
                        v: [
                            [
                                94.034,
                                3.421
                            ],
                            [
                                -0.447,
                                97.903
                            ],
                            [
                                -94.929,
                                3.421
                            ],
                            [
                                -0.447,
                                -91.061
                            ]
                        ],
                        c: true
                    },
                    ix: 1,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Trending 3').content('Group 1').content('Path 1').path;"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.596,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        9.969
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -9.969,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.596
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.629,
                                        -0.081
                                    ],
                                    [
                                        0,
                                        -11.546
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        12.26,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0.105,
                                        -11.655
                                    ],
                                    [
                                        13.678,
                                        3.12
                                    ],
                                    [
                                        0.147,
                                        9.804
                                    ],
                                    [
                                        11.489,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        14.495
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.596
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        9.969,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -9.969
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.596,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.629
                                    ],
                                    [
                                        11.528,
                                        0.08
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        12.26
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.656,
                                        0
                                    ],
                                    [
                                        -0.118,
                                        13.116
                                    ],
                                    [
                                        -9.559,
                                        -2.18
                                    ],
                                    [
                                        -0.171,
                                        -11.448
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -14.495,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -201.091,
                                        65.638
                                    ],
                                    [
                                        -201.091,
                                        39.52
                                    ],
                                    [
                                        -180.095,
                                        18.524
                                    ],
                                    [
                                        -117.179,
                                        18.524
                                    ],
                                    [
                                        -99.129,
                                        0.474
                                    ],
                                    [
                                        -99.129,
                                        0.473
                                    ],
                                    [
                                        -81.078,
                                        -17.577
                                    ],
                                    [
                                        -74.433,
                                        -17.577
                                    ],
                                    [
                                        -53.437,
                                        3.419
                                    ],
                                    [
                                        -53.437,
                                        23.917
                                    ],
                                    [
                                        -32.292,
                                        44.914
                                    ],
                                    [
                                        -11.445,
                                        65.909
                                    ],
                                    [
                                        -11.445,
                                        80.462
                                    ],
                                    [
                                        -33.644,
                                        102.661
                                    ],
                                    [
                                        -33.644,
                                        102.661
                                    ],
                                    [
                                        -85.687,
                                        102.661
                                    ],
                                    [
                                        -106.477,
                                        123.85
                                    ],
                                    [
                                        -132.416,
                                        144.089
                                    ],
                                    [
                                        -148.471,
                                        123.337
                                    ],
                                    [
                                        -169.464,
                                        102.661
                                    ],
                                    [
                                        -174.713,
                                        102.661
                                    ],
                                    [
                                        -200.958,
                                        76.416
                                    ],
                                    [
                                        -200.958,
                                        59.992
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 2",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 1,
                        ty: "sh",
                        ix: 2,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.596,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        9.969
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -9.969,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.596
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.629,
                                        -0.081
                                    ],
                                    [
                                        0,
                                        -11.546
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        12.26,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0.105,
                                        -11.655
                                    ],
                                    [
                                        13.678,
                                        3.12
                                    ],
                                    [
                                        0.147,
                                        9.804
                                    ],
                                    [
                                        11.489,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        14.495
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.596
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        9.969,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -9.969
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.596,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.629
                                    ],
                                    [
                                        11.528,
                                        0.08
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        12.26
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.656,
                                        0
                                    ],
                                    [
                                        -0.118,
                                        13.116
                                    ],
                                    [
                                        -9.559,
                                        -2.18
                                    ],
                                    [
                                        -0.171,
                                        -11.448
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -14.495,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -42.757,
                                        -77.059
                                    ],
                                    [
                                        -42.757,
                                        -103.177
                                    ],
                                    [
                                        -21.761,
                                        -124.173
                                    ],
                                    [
                                        41.156,
                                        -124.173
                                    ],
                                    [
                                        59.206,
                                        -142.223
                                    ],
                                    [
                                        59.206,
                                        -142.223
                                    ],
                                    [
                                        77.256,
                                        -160.273
                                    ],
                                    [
                                        83.901,
                                        -160.273
                                    ],
                                    [
                                        104.897,
                                        -139.277
                                    ],
                                    [
                                        104.897,
                                        -118.78
                                    ],
                                    [
                                        126.042,
                                        -97.783
                                    ],
                                    [
                                        146.889,
                                        -76.788
                                    ],
                                    [
                                        146.889,
                                        -62.234
                                    ],
                                    [
                                        124.69,
                                        -40.035
                                    ],
                                    [
                                        124.69,
                                        -40.035
                                    ],
                                    [
                                        72.647,
                                        -40.035
                                    ],
                                    [
                                        51.857,
                                        -18.846
                                    ],
                                    [
                                        25.919,
                                        1.392
                                    ],
                                    [
                                        9.864,
                                        -19.36
                                    ],
                                    [
                                        -11.13,
                                        -40.035
                                    ],
                                    [
                                        -16.379,
                                        -40.035
                                    ],
                                    [
                                        -42.624,
                                        -66.28
                                    ],
                                    [
                                        -42.624,
                                        -82.704
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 2,
                        ty: "sh",
                        ix: 3,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.596,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        9.969
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -9.969,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.596
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.629,
                                        -0.081
                                    ],
                                    [
                                        0,
                                        -11.546
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        12.26,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0.105,
                                        -11.655
                                    ],
                                    [
                                        13.678,
                                        3.12
                                    ],
                                    [
                                        0.147,
                                        9.804
                                    ],
                                    [
                                        11.489,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        14.495
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.596
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        9.969,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -9.969
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.596,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.629
                                    ],
                                    [
                                        11.528,
                                        0.08
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        12.26
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.656,
                                        0
                                    ],
                                    [
                                        -0.118,
                                        13.116
                                    ],
                                    [
                                        -9.559,
                                        -2.18
                                    ],
                                    [
                                        -0.171,
                                        -11.448
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -14.495,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        30.546,
                                        92.027
                                    ],
                                    [
                                        30.546,
                                        65.909
                                    ],
                                    [
                                        51.542,
                                        44.913
                                    ],
                                    [
                                        114.459,
                                        44.913
                                    ],
                                    [
                                        132.509,
                                        26.863
                                    ],
                                    [
                                        132.509,
                                        26.863
                                    ],
                                    [
                                        150.559,
                                        8.812
                                    ],
                                    [
                                        157.204,
                                        8.812
                                    ],
                                    [
                                        178.2,
                                        29.808
                                    ],
                                    [
                                        178.2,
                                        50.306
                                    ],
                                    [
                                        199.345,
                                        71.303
                                    ],
                                    [
                                        220.192,
                                        92.298
                                    ],
                                    [
                                        220.192,
                                        106.851
                                    ],
                                    [
                                        197.993,
                                        129.05
                                    ],
                                    [
                                        197.993,
                                        129.05
                                    ],
                                    [
                                        145.95,
                                        129.05
                                    ],
                                    [
                                        125.16,
                                        150.239
                                    ],
                                    [
                                        99.222,
                                        170.478
                                    ],
                                    [
                                        83.167,
                                        149.726
                                    ],
                                    [
                                        62.173,
                                        129.05
                                    ],
                                    [
                                        56.924,
                                        129.05
                                    ],
                                    [
                                        30.679,
                                        102.805
                                    ],
                                    [
                                        30.679,
                                        86.382
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 3",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.833,
                                        y: 0.833
                                    },
                                    o: {
                                        x: 0.167,
                                        y: 0.167
                                    },
                                    t: 8,
                                    s: [
                                        20,
                                        0
                                    ],
                                    to: [
                                        -6.667,
                                        0
                                    ],
                                    ti: [
                                        6.667,
                                        0
                                    ]
                                },
                                {
                                    t: 122.000004969162,
                                    s: [
                                        -20,
                                        0
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.525490224361,
                        0.450980395079,
                        0.705882370472,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.167,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 8.00000032584668,
        op: 908.000036983598,
        st: 8.00000032584668,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Trending",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234.053,
                    234.921,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.972549021244,
                                0.949019610882,
                                0.972549021244,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var World = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, World as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=World.json.es.js.map
